/**
 * The following Javascript Module provides scripting for the necessary
 * UX elements of the warranty landing page
 */

var formValidation = require('base/components/formValidation');

module.exports = {

    init: function () {
        // warrantyRequest form submit event
        $('form.warrantyRequest').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                        $('html, body').animate({
                            scrollTop: $('.is-invalid, .alert-danger', 'form.warrantyRequest').first().offset().top - 100
                        }, 500);
                    } else if (data.redirectUrl) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
            return false;
        });
    }
};
